//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Heartbeat
import Heartbeat from '../../plugins/Heartbeat';

export default {
    props: {
        title: {
            default: null
        },
        subtitle: {
            default: null
        }
    },
    mixins: [Heartbeat],
    computed: {
        filteredData: function filteredData() {
            var _this = this;

            var filterKey = this.filterKey && this.filterKey.toLowerCase();
            var data = this.properties.filter(function (f) {
                return !_this.hideProperties.includes(f.name);
            });
            if (filterKey) {
                data = data.filter(function (row) {
                    return Object.keys(row).some(function (key) {
                        return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
                    });
                });
            }
            return data;
        }
    },

    data: function data() {
        return {
            timeline: null,
            paused: true,
            loading: true,
            filterKey: '',
            properties: [],
            menuOpen: false,
            property: '',
            hovered: false,
            isAdmin: window.validator.can(['create-all', 'read-all', 'update-all', 'delete-all']),
            user: {},
            hideProperties: ['Madera Capital Holdings, Ltd', 'Madera Capital Management, LLC', 'Madera Equity, LLC', 'Madera Equity, LTD', 'Madera Pool', 'Madera Pool LLC', 'Madera Portfolio Management, LLC', 'Madera Residential GP, LLC', 'Madera Residential, LLC', 'Madera Residential, LTD']
        };
    },
    mounted: function mounted() {
        var _this2 = this;

        var $el = this;
        this.getProperties();
        axios.get('/prototype/u').then(function (response) {
            $el.user = response.data;
        });
        Event.$on('refresh-property-menu', function () {
            _this2.getProperties();
        });
    },
    destroyed: function destroyed() {
        Event.$off('refresh-property-menu');
    },


    methods: {
        getProperties: function getProperties() {
            var _this3 = this;

            var $el = this;

            axios.get('/prototype/menu').then(function (response) {
                $el.properties = response.data.properties;
                $el.property = response.data.selected;

                // Set window title
                if ($el.property) {
                    _this3.$store.state.selectedProperty = $el.property.id;
                    _this3.$store.state.selectedPropertyName = $el.property.name; // please use this going forward
                    localStorage.setItem('property-name', $el.property.name); // @TODO: this will become legacy to be removed
                    document.title = $el.property.name + ' - Madera Residential';
                    $el.loading = false;

                    // Put local property
                    localStorage.setItem('property-name', $el.property.name);
                } else {
                    _this3.$store.state.selectedProperty = response.data.properties[0].id;
                    _this3.$store.state.selectedPropertyName = response.data.properties[0].name;
                }
            });
        },
        showDefaultList: function showDefaultList() {
            Event.$emit('show-default-list');

            this.hovered = false;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/HeaderBar.vue
// module id = g7Ad
// module chunks = 0 1